import React from 'react';
import {withTranslation} from 'react-i18next';

import {UserInfo} from './context'
import {ensureDiscordAuth, forceDiscordAuth, getUserInfo} from "./discord";
import * as firebase from "firebase/app";

class LoginPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log("🔐 LoginPage: Starting authentication...");
    ensureDiscordAuth();
    getUserInfo().then((userInfo) => {
      console.log("🔐 LoginPage: Got user info:", userInfo);
      userInfo.actuallyAdmin = userInfo.admin;
      console.log("🔐 LoginPage: Setting state with userInfo:", userInfo);
      this.setState(userInfo);

      // firebase.firestore().collection("users").doc(userInfo.id).set({
      //   id: userInfo.id,
      //   name: userInfo.name,
      //   roles: {
      //     member: true,
      //     admin: userInfo.engineer,
      //     engineer: userInfo.engineer,
      //     finance: userInfo.finance,
      //     superuser: userInfo.superuser,
      //   },
      //   servers: userInfo.servers || [],
      //   balanceIsk: firebase.firestore.FieldValue.increment(0),
      //   balancePanda: firebase.firestore.FieldValue.increment(0),
      //   totalIsk: firebase.firestore.FieldValue.increment(0),
      //   totalPanda: firebase.firestore.FieldValue.increment(0),
      //   ordersPending: firebase.firestore.FieldValue.increment(0),
      //   ordersLimit: firebase.firestore.FieldValue.increment(0),
      //   transactionLimit: firebase.firestore.FieldValue.increment(0),
      //   lastLogin: +(new Date()),
      // }, {merge: true})

      // getServerUserInfo(userInfo.id).then((userServerInfo) => {
      //   console.log(userServerInfo)
      // });
    }).catch((error) => {
      console.error("🚨 LoginPage: Error getting user info:", error);
    });
  }

  render() {
    const { t } = this.props;
    return <UserInfo.Provider value={this.state}>
      {this.state.name ? this.props.children : <div className={"container-fluid text-center"}>
        <div className={"loader mb-2"} />
        <div className={"mb-2"}>{t('pages:login.loggingIn')}</div>
        <button className={"btn btn-danger btn-sm"} onClick={forceDiscordAuth}>{t('common:buttons.retryLogin')}</button>
        <p className={"text-muted text-left"}>
          {t('pages:login.troubleshooting.intro')}
          <ol>
            <li>{t('pages:login.troubleshooting.retry')}</li>
            <li>{t('pages:login.troubleshooting.adblocker')}</li>
            <li><a href={"https://balsamiq.com/support/faqs/browserconsole/"} target={"_blank"} rel={"noopener noreferrer"}>{t('pages:login.troubleshooting.consoleLink')}</a>, {t('pages:login.troubleshooting.screenshot')}</li>
          </ol>
        </p>
      </div>}
    </UserInfo.Provider>
  }
}

const TranslatedLoginPage = withTranslation(['pages', 'common'])(LoginPage);
export default TranslatedLoginPage;